// Afterpay/Clearpay is the ONLY checkout path that needs Stripe.js in the browser and
// cannot fall back without it.
//
//   credit card  -> plain inputs -> Rails -> ActiveMerchant server-side. No Stripe.js.
//   PayPal       -> its own SDK. No Stripe.js.
//   Apple/Google Pay -> needs Stripe.js, but degrades cleanly: Stripe.jsx guards on
//                       `if (stripe)` and renders nothing, so the express button is simply absent.
//   Afterpay     -> handleClearpay() calls stripe.confirmAfterpayClearpayPayment(...).
//
// Stripe.js is loaded once at the ROOT of the customer SPA (CustomerApp), so when it fails
// (adblocker, network, CSP) `useStripe()` stays null for the WHOLE session — including a
// checkout the customer navigates to client-side without a reload. Offering Afterpay in that
// state renders a payment option that throws a TypeError on submit and strands the customer
// mid-checkout with the button stuck submitting.
//
// So the option must be gated on Stripe actually being available, not just on the cart total.
export const MINIMUM_SUBTOTAL_FOR_AFTERPAY = 35;

export const canOfferAfterpay = ({
  cart,
  app,
  stripe,
  minimumSubtotal = MINIMUM_SUBTOTAL_FOR_AFTERPAY,
}) => {
  if (!stripe) return false;
  if (!cart) return false;
  if (app) return false;

  return Number(cart.subtotal) > minimumSubtotal;
};
